import { RetryLink } from "@apollo/client/link/retry";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";

import { logOutAction } from "../../store/slices/user";
import { store } from "../../store";
import { RETRY_LINK_ATTEMPTS_MAX, RETRY_LINK_DELAY_INITIAL } from "../../constants/app";

const createAuthLink = () => {
  return setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        Accept: "application/json",
        ContentType: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    };
  });
};

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    // eslint-disable-next-line

    if (graphQLErrors[0].message === "Unauthenticated.") {
      localStorage.clear();
      store.dispatch(logOutAction());
    }
  }
  if (networkError) {
    // eslint-disable-next-line
    console.log("networkError", networkError);
  }
});

const createRetryLink = () => {
  return new RetryLink({
    delay: {
      initial: Number(RETRY_LINK_DELAY_INITIAL || 300),
      max: Infinity,
      jitter: true
    },
    attempts: {
      max: Number(RETRY_LINK_ATTEMPTS_MAX || 5),
      retryIf: (error) => error && navigator.onLine
    }
  });
};

const getLinks = (apiBase: string) => {
  const authLink = createAuthLink();
  const retryLink = createRetryLink();

  const httpLink = createUploadLink({
    uri: apiBase,
    credentials: "include"
  });

  // preserve this array order, it's important
  // as the terminating link, `httpLink` must be last
  return new Map()
    .set("RETRY", retryLink)
    .set("AUTH", authLink)
    .set("ERROR", errorLink)
    .set("HTTP", httpLink);
};

export default getLinks;
